import React from 'react'
import uuid from 'react-id-generator'
import style from './comparisonTableItem.module.scss'

function TBody(props) {
   return (
      <>
         {props.cards.map((card, ndx) => (
            card.tables.map((table, idx) => (
               <>
                  {ndx === 0 && <div className={style.tableArray} key={uuid()}>
                     {<h2 className={style.tableTitle} key={uuid()}>{table.tableTitle}</h2>}
                     {<>
                        <table key={uuid()}>
                           <thead>
                              {idx < card.tables.length - 1 &&
                              <tr key={uuid()}>
                                 <>
                                    <th key={uuid()}>Website</th>
                                    {Object.keys(table).map((cell, idx) => (
                                       <>{idx > 0 && <th key={uuid()}>{cell}</th>}</>
                                    ))}
                                 </>
                                 </tr>}
                              </thead>
                                 <tbody key={idx}>
                                 <>
                              {idx < card.tables.length - 1
                                    ?                                    
                                 props.cards.map((card, i) => (
                                    <>
                                       {<tr key={uuid()}>
                                          <>
                                             {<td key={uuid()}>{
                                                card.title                                                
                                             }
                                             </td>}
                                             {card.tables.map((table, index) => (
                                                <>
                                                   {idx === index
                                                   &&
                                                   Object.keys(table).map((elem, i) => (
                                                      <>
                                                         {i > 0 && <td key={uuid()}>
                                                            {table[elem].toString() === 'true'
                                                               ?
                                                               <svg className={style.mark} viewBox='0 0 20 20'
                                                                    fill='none' xmlns='http://www.w3.org/2000/svg'>
                                                                  <circle cx='10' cy='10' r='10' fill='#95D4EC' />
                                                                  <path
                                                                     d='M4.48367 11.767C3.99893 11.27 3.99893 10.4637 4.48367 9.96681C4.96805 9.46947 5.75392 9.46947 6.23866 9.96681L8.33074 12.1133L13.6797 5.18696C14.1028 4.63759 14.8798 4.5442 15.4152 4.97785C15.9507 5.41192 16.0417 6.20914 15.6187 6.75851L9.47539 14.7138C9.42912 14.7869 9.37481 14.8563 9.31197 14.9203C8.82759 15.4176 8.04171 15.4176 7.55739 14.9203L4.4841 11.7671L4.48367 11.767Z'
                                                                     fill='white' />
                                                                  <circle cx='10' cy='10' r='8.75' fill='#95D4EC' />
                                                                  <path
                                                                     d='M5.17455 11.5474C4.75041 11.1125 4.75041 10.407 5.17455 9.97218C5.59838 9.53701 6.28603 9.53701 6.71017 9.97218L8.54074 11.8504L13.2211 5.78981C13.5913 5.30911 14.2712 5.2274 14.7397 5.60684C15.2082 5.98665 15.2878 6.68421 14.9177 7.16492L9.54231 14.1258C9.50182 14.1897 9.4543 14.2505 9.39931 14.3065C8.97548 14.7417 8.28784 14.7417 7.86406 14.3065L5.17493 11.5474L5.17455 11.5474Z'
                                                                     fill='white' />
                                                               </svg>
                                                               :
                                                               table[elem].toString() === 'false'
                                                                  ?
                                                                  <svg className={style.mark} viewBox='0 0 20 20'
                                                                       fill='none' xmlns='http://www.w3.org/2000/svg'>
                                                                     <g opacity='0.5'>
                                                                        <circle cx='10' cy='10' r='10' fill='#BDBDBD' />
                                                                        <path
                                                                           d='M4.4822 11.7739C3.99747 11.2769 3.99747 10.4706 4.4822 9.97365C4.96658 9.4763 5.75246 9.4763 6.23719 9.97365L8.32928 12.1202L13.6782 5.1938C14.1013 4.64442 14.8783 4.55104 15.4138 4.98468C15.9492 5.41876 16.0402 6.21597 15.6172 6.76534L9.47393 14.7207C9.42765 14.7937 9.37335 14.8631 9.3105 14.9271C8.82612 15.4245 8.04025 15.4245 7.55593 14.9271L4.48264 11.7739L4.4822 11.7739Z'
                                                                           fill='white' />
                                                                        <circle cx='10' cy='10' r='8.75'
                                                                                fill='#BDBDBD' />
                                                                        <path
                                                                           d='M5.17406 11.5474C4.74992 11.1125 4.74992 10.407 5.17406 9.97218C5.5979 9.53701 6.28554 9.53701 6.70968 9.97218L8.54026 11.8504L13.2206 5.78981C13.5908 5.30911 14.2707 5.2274 14.7392 5.60684C15.2077 5.98665 15.2873 6.68421 14.9172 7.16492L9.54182 14.1258C9.50133 14.1897 9.45381 14.2505 9.39883 14.3065C8.97499 14.7417 8.28735 14.7417 7.86357 14.3065L5.17444 11.5474L5.17406 11.5474Z'
                                                                           fill='white' />
                                                                     </g>
                                                                  </svg>
                                                                  :
                                                                  table[elem]}
                                                         </td>}
                                                      </>
                                                   ))}
                                                </>
                                             ))}
                                          </>
                                       </tr>}
                                    </>
                                 ))
                                 :
                                 <tr className={style.language__list} key={uuid()}>
                                    {props.cards.map((card, i) => (
                                       <>
                                          {Object.values(card.tables).map((cell, ind) => (
                                             <>
                                                {ind > 3 && Object.values(cell).map((lang, idx) => (
                                                   <>
                                                      {idx > 0 &&
                                                      <td className={style.language__list__item} key={uuid()}>{
                                                         document.documentElement.clientWidth < 1140
                                                            ?
                                                            lang.split(',').join(' ')
                                                            :
                                                            lang.split(',').join(',')
                                                      }</td>}
                                                   </>
                                                ))}
                                             </>
                                          ))}
                                       </>
                                    ))}
                                 </tr>}
                           </>
                           </tbody>
                        </table>
                     </>
                     }
                  </div>}
               </>
            ))
         ))}
      </>
   )
}

export default TBody